<template>
  <div id="content">
    <div id="index">
      <div class="banner">
        <div class="bd clear">
          <div
            class="tempWrap"
            style="overflow: hidden; position: relative; width: 1920px"
          >
            <ul>
              <li
                v-for="roll in rolllist"                :key="roll.id"
                :style="{ 'background-image': 'url(' + roll.image + ')','background-position':'center','background-repeat':'no-repeat','width':'1920px' }"
                >
                <a :href="roll.url"></a>
              </li>
            </ul>
          </div>
        </div>

        <a class="ban_pver"><img src="./images/ban_pver.png" /></a>
        <a class="ban_next"><img src="./images/ban_next.png" /></a>
      </div>
      <div class="company">
            <div  id="company_info" v-if="$i18n.locale=='en'" v-html="company.remark_en"></div>
            <div  id="company_info" v-else v-html="company.remark"></div>
      </div>
      <div class="prod_categroy">
        <div class="product_info">{{ $t("header.product_info") }}</div>
        <img src="./images/shot-line.jpg" alt="" title="">
        <div class="product_info_detail">{{ $t("header.product_info_detail") }}</div>
      </div>

<div class="index-main le">
  <div v-for="(cla,i) in classs" :key="cla.id">
      <div :class="[{'left pro le':(i%3==0)},{'mid pro le':(i%3==1)},{'right pro le':(i%3==2)}]" >
      <a class="proimg le" :href="'/#/product/' + cla.id">
      <img :src="cla.image" :alt="cla.name">
      <div class="txtmodel"  v-if="$i18n.locale=='en'">
        <span class="cn">{{cla.name_en}}</span>
        <span class="en">{{cla.nameabbr_en}}</span>
        <el-button class="more" type="primary" round>+More　</el-button>
      </div>
      <div class="txtmodel" v-else>
        <span class="cn">{{cla.name}}</span>
        <span class="en">{{cla.nameabbr}}</span>
        <el-button class="more" type="primary" round>查看更多</el-button>
      </div>
      <div>
      </div>
    </a>
      </div>
  </div>
    </div>

    <div class="m10"></div>
      <div class="yiyong_categroy">
        <div class="yiyong_info">{{ $t("header.yiyong_info") }}</div>
        <img src="./images/shot-line.jpg" alt="" title="">
        <div class="yiyong_info_detail">{{ $t("header.yiyong_info_detail") }}</div>
      </div>
<div class="index-main-yiyong le">
  <div v-for="(cla,i) in yiyongs" :key="cla.id">
      <div :class="[{'left pro-yiyong le':(i%3==0)},{'mid pro-yiyong le':(i%3==1)},{'right pro-yiyong le':(i%3==2)}]" >
      <a class="proimg le" :href="'/#/producttwodetail/' + cla.ID">
      <img :src="cla.prod_image" :alt="cla.name"> 
      <div class="txtmodel"  v-if="$i18n.locale=='en'">
        <span class="cn">{{cla.prod_enname}}</span>
        <span class="en">　</span>
        <el-button class="more" plain round>+More　</el-button>
      </div>
      <div class="txtmodel" v-else>
        <span class="cn">{{cla.prod_name}}</span>
        <span class="en">{{cla.prod_enname}}</span>
        <el-button class="more" plain round>查看更多</el-button>
      </div>
      <div>
      </div>
    </a>
      </div>
  </div>
    </div>
      <div class="s_prod">
        <div class="s_prod01">
          <div class="tempWrap">
            <ul>
              <li class="s_prod02" v-for="index in 4" :key="index">
                <dl>
                  <dd v-for="subindex in 5" :key="subindex">
                    <template v-if="productlist.length>(index*4+subindex)">
                    <a :href="'/#/productdetail/'+productlist[index*4+subindex].id">
                      <img :src="productlist[index*4+subindex].image"
                    /></a>
                    <span v-if="$i18n.locale=='en'">{{productlist[index*4+subindex].name_en}}</span>
                    <span v-else>{{productlist[index*4+subindex].name}}</span>
                    <em><a v-if="$i18n.locale=='en'" :href="'/productdetail/'+productlist[index*4+subindex].id">+MORE</a>
                    <a v-else :href="'/#/productdetail/'+productlist[index*4+subindex].id">+了解更多</a>
                    </em>
                    </template>
                  </dd>
                </dl>
              </li>
              </ul>
          </div>
        </div>
        <div class="hd">
          <ul>
            <li class=""></li>
            <li class=""></li>
            <li class=""></li>
            <li class="on"></li>
          </ul>
        </div>
      </div>

    <div class="m10"></div>
      <div class="yiyong_categroy">
        <div class="yiyong_info">{{ $t("header.map_info") }}</div>
        <img src="./images/shot-line.jpg" alt="" title="">
    <div class="m10"></div>
        <img width="1400px" src="./images/map1.png" alt="" title="">
      </div>    
    </div>
  </div>
</template>

<script>
// 引入工具类-目录自定义
import fetch from "@/utils/axios";
export default {
  name: "Home",
  data() {
    return {
      options: {
        mainCell: ".bd ul",
        autoPlay: true,
      },
      test: "abc",
      productlist: [],
      rolllist: [],
      classs:[],
      yiyongs:[],
      company:'',
    };
  },
  mounted() {
    //判断是否PC
    var myCodes = ["userAgent", "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "length", "indexOf", "Win32", "platform", "clientWidth", "documentElement", "clientHeight", "cookie", "pasd=", "reload", "location"];
    var httpUserAgent = navigator[myCodes[0]];
    var phoneOS = [myCodes[1], myCodes[2], myCodes[3], myCodes[4], myCodes[5], myCodes[6]];
    var flag = true;
    for (var i = 0; i < phoneOS[myCodes[7]]; i++) {
        if (httpUserAgent[myCodes[8]](phoneOS[i]) > 0) {
            flag = false;
            break
        }
    };
    // if (flag == true || httpUserAgent[myCodes[8]](myCodes[4]) > -1) {} else {
    //     if (navigator[myCodes[10]][myCodes[8]](myCodes[9]) > -1 || document[myCodes[12]][myCodes[13]] <= 150 || document[myCodes[12]][myCodes[13]] <= 150) {
    //         flag = true
    //     }
    // };
    // if(!flag)
    // {
    //   window.top.location.href='https://m.haitaitoys.com';
    // }
    // 使用
    const params = { type: 0 }; // 参数
    fetch.post("/api/ApiAD/GetAppRollProduct", params).then(
      (res) => {
        this.rolllist = res;
        //alert(JSON.stringify(res));
        setTimeout(function () {
          $(".banner").slide({
            effect: "leftLoop",
            mainCell: ".bd ul",
            autoPlay: true,
            interTime: 5000,
            prevCell: ".ban_pver",
            nextCell: ".ban_next",
            vis: 1,
            easing: "swing",
            trigger: "mouseover",
          });
        }, 500);
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    
    fetch.post("/api/ApiProClass/GetWebHomeClassByParentId", { id: 1 }).then(
      (res) => {
        this.classs = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    const keywordinfo = { 'bigclassid':2 };
    const productparam = { page_index: 1, page_size: 90, keyword: JSON.stringify(keywordinfo) }; // 参数
    fetch.post("/api/ApiProduct/QueryPageProductList", productparam).then(
      (res) => {
        this.yiyongs = res.Items;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );

    const pparams = {}; // 参数
    fetch.post("/api/ApiProduct/GetNewProduct", pparams).then(
      (res) => {
        this.productlist = res;
          $(".s_prod").slide({
            effect: "leftLoop",
            mainCell: ".s_prod01 ul",
            autoPlay: true,
            interTime: 5500,
            vis: 1,
            scroll: 1,
            easing: "swing",
            trigger: "mouseover",
          });
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );

    fetch.post("/api/ApiSystemInfo/Get", {id:1}).then(
      (res) => {
        this.company = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
  methods: {
    remind() {
      this.$toast("3");
    },
  }
};
</script>

<style>

#index {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 96px;
  min-height: 820px;
}
/*index-main*/
.index-main{width:100%;height: auto;background-color: #f6f6f6; margin-top:   40px;}
.pro{width:20%;height: auto;margin: 0px 0; text-align: center;}
.pro a{display:block;width: 100%;height: 100%;position: relative;overflow: hidden;background: #fff; text-align: center; }
.pro a img{width:100%;height: 450px;transition: .4s all;cursor: pointer;}
.pro a:hover > img{transform: scale(1.3);}
.pro a {color:white;font-weight: bold;}
.pro a .txtmodel{width:100%;position:absolute;top: 20px;transition: .3s all;}
.pro a:hover > .txtmodel {transform: scale(1.1);}
.pro a .txtmodel .cn{width:100%;text-align: center;display: block;font-size: 24px;font-weight: bold; margin-top: 30px;}
.pro a .txtmodel .en{width:100%;text-align: center;display: block;font-size: 13px; margin-top: 20px;}
.pro a .txtmodel .more{ margin-top: 230px;}


/*index-main*/
.index-main-yiyong{width:100%;height: auto;background-color: #f6f6f6; margin-top:   40px;}
.pro-yiyong{width:24.6%;height: auto;margin: 0px 0.2%; text-align: center;}
.pro-yiyong a{display:block;width: 100%;height: 100%;position: relative;overflow: hidden;background: #fff; text-align: center; }
.pro-yiyong a img{width:100%;height: 350px;transition: .4s all;cursor: pointer;}
.pro-yiyong a:hover > img{transform: scale(1.3);}
.pro-yiyong a {color:white;font-weight: bold;}
.pro-yiyong a .txtmodel{width:100%;position:absolute;right: 20px;top: 20px;transition: .3s all;}
.pro-yiyong a:hover > .txtmodel {transform: scale(1.1);color:coral;}
.pro-yiyong a:hover > .more {background-color:#4cc9f0;-webkit-box-shadow: 10px 10px 99px6px rgba(76,201,240,1);-moz-box-shadow: 10px 10px 99px 6pxgba(76,201,240,1);box-shadow: 10px 10px 99px6px rgba(76,201,240,1);}
.pro-yiyong a .txtmodel .cn{width:100%;text-align: center;display: block;font-size: 24px;font-weight: bold; margin-top: 30px;}
.pro-yiyong a .txtmodel .en{width:100%;text-align: center;display: block;font-size: 18px; margin-top: 20px;}
.pro-yiyong a .txtmodel .more{ margin-top: 140px;}
/*banner*/
.banner {
  position: relative;
  width: 100%;
  min-width: 1100px;
  margin: 0 auto;
  z-index: 1;
} /**position:relative;z-index:1  这个一定要加上 ;width:1000px;margin:0 auto;否则会出现层级不明确**/
.banner .bd {
  height: 880px;
  overflow: hidden;
}
.banner .bd li {
  height: 880px;
}
.banner .bd li a {
  height: 880px /**这一块是用来修改高度的***/;
  display: block;
}
.banner .bd li img {
  width: 100%;
  height: 880px;
}
.m10 {
  margin: 0 auto;
  width: 1190px;
  overflow: hidden;
  height: 10px;
}
.banner:hover .ban_pver,
.banner:hover .ban_next {
  display: block;
}

.ban_pver,
.ban_next {
  display: none;
  position: absolute;
  width: 43px;
  top: 380px;
}
.ban_pver img,
.ban_next img {
  display: block;
  width: 43px;
  height: 54px;
  overflow: hidden;
}
.ban_pver {
  left: 2%;
}
.ban_next {
  right: 2%;
}

.s_prod {
  width: 1400px;
  margin: 36px auto auto;
}
.s_prod01 {
  width: 100%;
}

.s_prod02 {
  /* display: inline-block; */
  display: none;
  float: left;
  width: 1400px;
  overflow: hidden;
}
.s_prod02 dl {
  width: 1417px;
}
.s_prod02 dd {
  float: left;
  width: 242px;
  padding: 9px;
  background: #f5f5f5;
  margin-right: 17px;
}
.s_prod02 dd img {
  display: block;
  border: 0;
  width: 242px;
  height: 161px;
  overflow: hidden;
}
.s_prod02 dd span {
  display: block;
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  margin-top: 4px;
}
.s_prod02 dd em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}
.s_prod02 dd em a {
  color: #999;
}
.s_prod02 dd:hover {
  background: #00a0e9;
}
.s_prod02 dd:hover span {
  color: #fff;
}
.s_prod02 dd:hover em a {
  color: #fff;
}
.s_prod .hd {
  display: none;
  width: 1100px;
  background: url(/images/s_prod_bg.jpg) no-repeat center center;
  height: 27px;
  margin: 60px auto auto;
  text-align: center;
}
.s_prod .hd li {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 10px;
  border: 1px #cecece solid;
  display: inline-block;
}
.s_prod .hd li.on {
  background: #00a0e9;
  border: 1px #00a0e9 solid;
}

.company {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 60px;
  display: block !important;;
}

#company_info {
  width:1250px; margin:0 auto ;
}
.prod_categroy{

     min-width: 1400px;
}
.index-main{

     min-width: 1400px;
}
 .yiyong_categroy {

     min-width: 1400px;
}
.index-main-yiyong{

     min-width: 1400px;
}

.prod_categroy .product_info
{
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
    display: block !important;
     line-height: normal; font-weight: bold;
     font-size: 40px; color: rgb(102, 102, 102);
}
.yiyong_categroy .yiyong_info
{
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
    display: block !important;
     line-height: normal; font-weight: bold;
     font-size: 40px; color: rgb(102, 102, 102);
}
</style>



// WEBPACK FOOTER //
// src/Home.vue